import { render, staticRenderFns } from "./OperationRemittance.vue?vue&type=template&id=2be9ebfa&scoped=true"
import script from "./OperationRemittance.vue?vue&type=script&lang=js"
export * from "./OperationRemittance.vue?vue&type=script&lang=js"
import style0 from "./OperationRemittance.vue?vue&type=style&index=0&id=2be9ebfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be9ebfa",
  null
  
)

export default component.exports